import React from 'react'

import TertiaryNav from 'components/TertiaryNav'

import { useTertiary } from '../navigation'
import PageTransitions from 'transitions/transitions'

import styled from 'styled-components'
import { getTransition } from 'transitions/next-prev'
import { allTransitions } from 'transitions/app-transitions'

export const getActiveTabIndex = tabs => {
  return tabs.findIndex(t => t.active)
}

export const getTertiaryTransition = (from, to) => {
  const fromIndex = getActiveTabIndex(from)
  const toIndex = getActiveTabIndex(to)
  return getTransition(fromIndex, toIndex)
}

const TertiaryDiv = styled.div`
  position: relative;
`

const TertiaryContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backface-visibility: hidden;
  transform: translate3d(0, 0, 0);
  ${allTransitions}
`

const TertiaryDivision = ({ children, tabFilter }) => {
  const { tertiary = [], prevTertiary = [] } = useTertiary()

  const transition = getTertiaryTransition(
    prevTertiary,
    tertiary
  )
  const tabs = tabFilter ? tertiary.filter(tabFilter) : tertiary
  const tab = tabs.find(t => t.active) || prevTertiary.find(t => t.active)
  const key = tab?.type

  return (
    <div>
      <TertiaryNav tabs={tabs} />
      <TertiaryDiv>
        <PageTransitions {...transition} id={key}>
          <TertiaryContent>
            {children}
          </TertiaryContent>
        </PageTransitions>
      </TertiaryDiv>
    </div>
  )
}

export default TertiaryDivision
